export const UPDATE_SEND_INVITE_EMAIL = 'UPDATE_SEND_INVITE_EMAIL';
export const SEND_INVITE_LOADING = 'SEND_INVITE_LOADING';
export const SEND_INVITE_SUCCESS = 'SEND_INVITE_SUCCESS';
export const SEND_INVITE_ERROR = 'SEND_INVITE_ERROR';
export const SEND_INVITE_CLEAR_MESSAGE = 'SEND_INVITE_CLEAR_MESSAGE';
export const SET_TIMEOUT_ID = 'SET_TIMEOUT_ID';
export const SET_IS_EXPANDED = 'SET_IS_EXPANDED';
